module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1700.d6a38b95.svg";